import React, { useContext } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { TaskContext } from 'context/TaskContext';
import theme from 'theme';
import { CircularProgressWithLabelProps } from './CircularProgressWithLabel.props';
import { circularProgressWithLabelClasses, StyledCircularProgressBox } from './CircularProgressWithLabel.styles';


const CircularProgressWithLabel = (props: CircularProgressWithLabelProps) => {
  const { progress, numberStyles, circleSize } = props;

  const { isMobile } = useContext(TaskContext) || {};
  const { color: customColor, fontSize: customFontSize } = numberStyles || {
    color: theme.palette.primary[900],
    fontSize: '0.75rem',
  };

  // Validate progress is a number and is between 0 and 100
  const validProgress
    = typeof progress === 'number' && !Number.isNaN(progress) ? Math.min(Math.max(progress, 0), 100) : 0;

  return (
    <StyledCircularProgressBox sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={100}
        size={isMobile ? '6rem' : (circleSize ?? '3.75rem')}
        style={{
          color: theme.palette.grey?.[300],
          opacity: 0.4,
        }}
      />
      <CircularProgress
        variant="determinate"
        value={validProgress}
        size={isMobile ? '6rem' : (circleSize ?? '3.75rem')}
        style={{
          color: theme.palette.secondary[600],
          position: 'absolute',
          left: 0,
        }}
      />
      <Box className={circularProgressWithLabelClasses.circleNumberBox}>
        <Typography
          variant="caption"
          component="div"
          style={{
            fontWeight: 800,
            fontSize: isMobile ? '1.5rem' : customFontSize,
            color: customColor,
          }}>
          {`${Math.round(validProgress)}%`}
        </Typography>
      </Box>
    </StyledCircularProgressBox>
  );
};

export default CircularProgressWithLabel;
